import { Injectable } from "@angular/core";
import { CompanyComputerLensesService } from "../repositories/company-computer-lenses.service";
import { CompanyDressLensesService } from "../repositories/company-dress-lenses.service";
import { CompanyLensesService } from "../repositories/company-lenses.service";
import { CompanyRespiratorLensesService } from "../repositories/company-respirator-lenses.service";
import { ORDER_CATEGORY } from "src/app/helpers/order-categories.helper";
import { LENS_TYPES } from "src/app/helpers/lenses.helper";
import { CompanyLenses } from "src/app/models/company-lenses.model";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { CartManagerService } from "./cart-manager.service";
import { CompanyLensTypeVM } from "src/app/models/view-models/company-lens-type-vm.model";


@Injectable({
    providedIn: 'root'
  })

  export class CompanyLensesHelperService {

    constructor(private _cartManagerService: CartManagerService,
                private _companyLensesService: CompanyLensesService,
                private _companyDressLensesService: CompanyDressLensesService,
                private _companyComputerLensesService: CompanyComputerLensesService,
                private _companyRespiratorLensesService: CompanyRespiratorLensesService) { }
    
    getAllLenses(): Observable<CompanyLensTypeVM> {
        const cartItem = this._cartManagerService.getTempCartItem();
        let lensObservable!: Observable<CompanyLenses[]>;
        if (cartItem) {
          switch (cartItem?.itemCategory) {
            case ORDER_CATEGORY.glasses:
              lensObservable = this._companyLensesService.getLenses();
              break;
            case ORDER_CATEGORY.computerGlasses:
              lensObservable = this._companyComputerLensesService.getLenses();
              break;
            case ORDER_CATEGORY.dressGlasses:
              lensObservable = this._companyDressLensesService.getLenses();
              break;
            case ORDER_CATEGORY.respiratorInserts:
              lensObservable = this._companyRespiratorLensesService.getLenses();
              break;
            default:
              throw Error('missing item category');
          }
          return this.populateAndSortLenses(lensObservable);
        }
        else {
          throw Error('no cart item');
        }
      }

      populateAndSortLenses(lensObservable: Observable<CompanyLenses[]>): Observable<CompanyLensTypeVM> {
       return lensObservable
        .pipe(map(res => {
            const prescriptionLenses = res
                .filter(res => res.visionType == LENS_TYPES.singleVision || res.visionType == LENS_TYPES.bifocal ||
                  res.visionType == LENS_TYPES.progressive
                );
            const readerLenses = res
                .filter(cl => cl.visionType == LENS_TYPES.singleVisionReaders);
            const planoLenses = res
                .find(cl => cl.visionType == LENS_TYPES.plano);
            const companyLensVM: CompanyLensTypeVM = {
              prescriptionLenses: prescriptionLenses,
              readerLenses: readerLenses, 
              planoLenses: planoLenses
            }
            return companyLensVM;   
          }));
      }
    }